import lessRequire from '../../../../config/less-require-resolver';
import PropTypes from 'prop-types';
import React from 'react';

lessRequire('modules/offers/components/table/booster-info-banner.less');

const propTypes = {
	intl: PropTypes.func,
	shouldShowBooster: PropTypes.bool
};

const BoosterInfoBanner = ({intl, shouldShowBooster}) => (
	<div className="offer-geo-booster-info-banner">
		{shouldShowBooster && (
			<div className="boost-wrap">
				<div className="boost-label font-proxima-nova-semibold">
					Boost
				</div>
				<div className="boost-description">{intl('На 7 дней или на первых 500 подтвержденных лидов')}</div>
			</div>
		)}
	</div>
);

BoosterInfoBanner.propTypes = propTypes;

export default BoosterInfoBanner;



// WEBPACK FOOTER //
// ./frontend/cabinets/modules/offers/components/table/booster-info-banner.js